export const calendar = {
  title: "Kalendarz",
  subtitle: "Zarządzaj rezerwacjami swoich obiektów",
  createBooking: "Utwórz rezerwację",
  propertyLabel: "Obiekt",
  searchPlaceholder: "Szukaj obiektu",
  filterByProperty: "Filtruj obiekty",
  clearFilters: "Wyczyść filtry",
  loadingMore: "Wczytywanie kolejnych dat…",

  payment: {
    "pending":  "Płatność oczekująca",
    "paid":     "Opłacone",
    "rejected": "Płatność odrzucona",
    "refunded": "Zwrócone",
    "partial":  "Płatność częściowa"
  },

  tooltips: {
    noChannels: "Brak połączenia z jakimkolwiek kanałem",
    connectedTo: "Połączono z: {channels}",
    manual: "WA Checkin (ręcznie)",
    other: "Inny kanał",
    configPrices: "Konfiguruj ceny",
  },

  errors: {
    loadCalendar: "Błąd wczytywania danych kalendarza",
    updateViewAfterCancel: "Błąd aktualizacji widoku po anulowaniu",
    closeDates: "Błąd zamykania dat",
    deleteClosedDates: "Błąd usuwania zamkniętych dat",
    updateClosedDates: "Błąd aktualizacji zamkniętych dat",
  },

  filters: {
    showPrices: "Pokaż ceny",
    today: "Dziś",
    multi: "Wiele",
    monthly: "Miesięcznie",
    prevMonthAria: "Poprzedni miesiąc",
    nextMonthAria: "Następny miesiąc",
  },

  actions: {
    title: "Wybierz działanie",
    question: "Co chcą Państwo zrobić z wybranymi datami?",
    createBooking: "Utwórz rezerwację",
    blockDates: "Zamknij datę",
    editNightPrice: "Edytuj cenę za noc",
    editMinStay: "Minimalny pobyt",
    editMinStayHint: "Ustaw minimalną liczbę nocy dla daty",
  },
  minStayModal: {
    description:
      "Ustaw minimalny pobyt dla wybranego zakresu dat. Nie wpłynie to na istniejące ceny.",
    success: "Minimalny pobyt zaktualizowany pomyślnie",
    hint: "Minimalna liczba nocy, którą gość musi zarezerwować.",
    errors: {
      minOne: "Minimalny pobyt musi wynosić co najmniej 1 noc.",
    },
  },

  fields: {
    startDate: "Data początkowa",
    endDate: "Data końcowa",
  },

  buttons: {
    delete: "Usuń",
    cancel: "Anuluj",
    save: "Zapisz",
    close: "Zamknij",
    saveChanges: "Zapisz zmiany",
    closeDates: "Zamknij daty",
  },

  closeModal: {
    headerCreate: "ZAMKNIJ DATY",
    headerEdit: "EDYTUJ ZAMKNIĘTE DATY",
  },

  priceModal: {
    description:
      "To ręczna zmiana wybranej stawki. Wszystko, co tutaj Państwo zmienią, wpłynie wyłącznie na ten obiekt i ten zakres dat.",
    periodLabel: "Okres",
    startPlaceholder: "Data początkowa",
    endPlaceholder: "Data końcowa",
    pricePerNight: "Cena za noc",
    minStay: "Minimalny pobyt",
    minNightsPlaceholder: "Minimalna liczba nocy",
    pricePlaceholder: "Cena dla wybranego zakresu",
    success: "Ceny zaktualizowane pomyślnie",
    errors: {
      invalidRange: "Należy wybrać prawidłowy zakres dat",
      startAfterEnd: "Data początkowa nie może być późniejsza niż data końcowa",
      minStay:
        "Minimalny pobyt to {min} nocy, a wybrany zakres obejmuje {nights} nocy",
      missingSelection: "Nie wybrano obiektu ani zakresu dat",
      request: "Błąd żądania: {msg}",
      update: "Błąd aktualizacji cen: {msg}",
    },
  },

  details: {
    header: "Szczegóły rezerwacji",
    title: "Rezerwacja",
    createdOn: "Utworzono {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Status",
    status: {
      booked: "Zarezerwowane",
      blocked: "Zablokowane",
    },
    night_one: "Noc",
    night_other: "Noce",
    actions: {
      view: "Zobacz rezerwację",
      changeRoom: "Zmień pokój",
      cancel: "Anuluj rezerwację",
    },
  },
};

export default calendar;
